module.exports = __webpack_public_path__ + "static/zmiany-2-7593edcb20b05e2236ace7308b96a9f9.jpg";